import React, { useState } from "react";

type SalesTargetTableProps = {
    isLoading: boolean;
    thought?: string;
    idx?: number;
};

const SalesTargetThinkingState = ({ isLoading, thought, idx }: SalesTargetTableProps) => {
    const [showThoughtIdx, setShowThoughtIdx] = useState<number>(-1);

    return (
        <div className="gradient-border p-3 w-[397px]  max-w-[90%]">
            <div className="">
                <div className="flex items-center gap-2 justify-between ">
                    <div className="flex items-center gap-2">
                        <i
                            className={`ri-sparkling-fill ${
                                isLoading && "animate-spin"
                            } text-sm bg-gradient-to-r from-[#56B648] to-[#FFB902] bg-clip-text text-transparent`}
                        ></i>
                        <p className="text-sm text-g-75 animate-pulse">Thinking</p>

                        {/* <p className={`text-sm text-g-75 ${isLoading ? "animate-pulse" : ""}`}>
                            {isLoading
                                ? "Thinking"
                                : showThoughtIdx !== -1
                                ? "Show thought"
                                : "Hide thought"}
                        </p> */}
                    </div>
                    {/* 
                    {thought && (
                        <i
                            className="ri-arrow-down-s-line text-md text-slate-500 cursor-pointer"
                            onClick={() => {
                                setShowThoughtIdx(showThoughtIdx === idx ? -1 : idx);
                            }}
                        ></i>
                    )} */}
                </div>
                {/* {showThoughtIdx === idx && <p className="text-sm text-g-75">{thought}</p>} */}
            </div>
        </div>
    );
};

export default SalesTargetThinkingState;
